<template>
  <v-dialog
    :value="value"
    max-width="600px"
    max-height="292px"
    overlay-color="var(--ds-color-reverse)"
    @input="cancelAction"
  >
    <v-card class="pb-5">
      <v-toolbar
        width="100%"
        class="px-2"
        color="transparent"
        flat
      >
        <v-toolbar-title class="add-card-modal__title">
          {{ $t('components.AddCardModal.label.title') }}
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-row
        no-gutters
        class="mt-5 mx-5"
      />
      <v-card-text class="add-card-modal__description">
        {{ $t('components.AddCardModal.label.description') }}
      </v-card-text>

      <v-card-actions class="px-6">
        <v-spacer />
        <DsButton
          color="secondary"
          @click="cancelAction"
        >
          {{ $t('components.AddCardModal.label.button.cancelButton') }}
        </DsButton>
        <DsButton
          class="ds-margin-left-stack--xs"
          @click="confirmAction"
        >
          {{ $t('components.AddCardModal.label.button.confirmButton') }}
        </DsButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DsButton } from '@ds/components';
import { MUTATE } from '@/store/modules/mutation_types';
import { mapMutations } from 'vuex';

export default {
  name: 'AddCardModal',
  components: {
    DsButton,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    ...mapMutations('misc', {
      mutateMisc: MUTATE,
    }),
    cancelAction() {
      this.$noty.success(this.$t('components.AddCardModal.label.message.cancel'), { layout: 'bottomCenter' });
      this.$emit('input', false);
      this.mutateMisc({
        property: 'addCardDrawer',
        with: true,
      });
    },
    confirmAction() {
      this.$emit('addChart');
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped lang="scss">
  .add-card-modal {
    &__title {
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-lg);
    }

    &__description {
      font-size: var(--ds-font-size-baseline);
      color: var(--ds-color-text-1) !important;
      margin-bottom: var(--ds-spacing-stack-xs);
    }

    &__text_button {
      color: var(--ds-color-icon-interactive);
      text-decoration: underline;
      text-transform: none;
    }
  }
</style>
